import { Stack, Box} from "@mui/material";
import { useEffect, useState } from "react";

import { useSelector } from "react-redux";
import MapView from "./MapView";
import useLiveDBSMLocatioins from "../../hooks/LiveDashboard/useLiveDBSMLocatioins";
const LiveMapView = () => {

  const dropDownData = useSelector((state) => state.app.curretDropdownData);
  const LPDetails = useSelector((state) => state.login.refreshToken?.user_data);
  
  const liveMapData = useLiveDBSMLocatioins();

  useEffect(() => {
    const param = {
      zone_id: dropDownData?.zone_id,
    //   partner_id: LPDetails?.partner_id
    };

    liveMapData(param);

    // Set up interval to call deliveryMapData every 15 seconds
    const id = setInterval(() => {
      liveMapData(param);
    }, 10000);

    // Clear interval on component unmount
    return () => clearInterval(id);
  }, [dropDownData]);

  return (
    <div>
      <Stack
        sx={{
          flexDirection: "row",
          backgroundColor: "#E5E5E5",
          fontFamily: "'Roboto', sans-serif",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", lg: "row" },
            gap: "6px",
            justifyContent: "space-between",
            paddingRight: "5px",
            paddingTop: "5px",
            backgroundColor: "#E5E5E5",
            height: "fit-content",
            width: "calc(100vw - 95px)",
          }}
        >
          <Stack sx={{ width: "100%", height: "100%" }}>
            <MapView/>
          </Stack>
        </Box>
      </Stack>
    </div>
  );
};

export default LiveMapView;
